import React from "react";

import { withRouter } from "react-router-dom";
import { Spinner } from 'react-bootstrap';

export class LoadingScreen extends React.Component {
	
	constructor(props) {
        super(props);
        this.state = {
			
		}
	}
	
	render() {
		return (
			<div className="showingWebData">
				<div className="row my-3">
					<div className="col">
						<div className="row">
							<div className="col">
								Loading...
							</div>
						</div>
						<div className="row">
							<div className="col">
								<Spinner animation="border" variant="primary" />
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default withRouter(LoadingScreen);